/** @param {string} [details] CT error_details text */
export function parseAccountNumbersFromErrorDetails(details) {
  if (!details) return [];
  const text = String(details);
  const fromLabel = text.match(/account\(s\):\s*(.+?)(?:\.|$)/i);
  if (fromLabel) {
    return fromLabel[1]
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }
  return [...text.matchAll(/\b(SIM[A-Z0-9]+)\b/gi)].map((m) => m[1].toUpperCase());
}

export const CT_CONNECT_ERROR_SESSION_KEY = 'pt_ct_connect_error';

export function readConnectTradeCallbackParams(search) {
  const params = new URLSearchParams(search);
  const ctError = params.get('ct_error');
  const ctErrorCode = params.get('ct_error_code');
  const ctErrorDetails = params.get('ct_error_details');
  const ctErrorAccounts = params.get('ct_error_accounts');
  const ctSuccess = params.get('ct') === '1';
  const hasCallback =
    ctSuccess || Boolean(ctError) || Boolean(ctErrorCode) || Boolean(ctErrorDetails) || Boolean(ctErrorAccounts);
  return {
    hasCallback,
    ctSuccess,
    ctError,
    ctErrorCode,
    ctErrorDetails,
    ctErrorAccounts,
  };
}

export function hasConnectTradeCallbackQuery(search) {
  return readConnectTradeCallbackParams(search).hasCallback;
}

export function formatConnectTradeConnectError({
  ctError,
  ctErrorCode,
  ctErrorDetails,
  ctErrorAccounts,
} = {}) {
  const isAccountInUse =
    ctError === 'broker_account_in_use' ||
    (ctError === 'oauth' && ctErrorCode === 'connection_already_exists');

  if (isAccountInUse) {
    const accountsFromParam = ctErrorAccounts
      ? ctErrorAccounts.split(',').map((s) => s.trim()).filter(Boolean)
      : [];
    const accounts =
      accountsFromParam.length > 0
        ? accountsFromParam
        : parseAccountNumbersFromErrorDetails(ctErrorDetails);

    if (accounts.length > 0) {
      return `These TradeStation accounts (${accounts.join(', ')}) are already linked to another Precision Trader login. Each broker account can only be connected to one user at a time. Sign in as the user who connected them, or disconnect the broker there first.`;
    }
    return 'This TradeStation account is already linked to another Precision Trader login. Each broker account can only be connected to one user at a time.';
  }

  const messages = {
    oauth: 'Connect Trade authorization was cancelled or failed.',
    missing_connection: 'Connect Trade did not return a connection ID.',
    server: 'Could not save your Connect Trade connection. Try again.',
  };

  if (ctError === 'oauth' && ctErrorDetails) {
    return `Connect Trade authorization failed: ${ctErrorDetails}`;
  }

  return messages[ctError] || 'Connect Trade connection failed.';
}

export function persistConnectTradeConnectError(message) {
  if (!message) return;
  try {
    sessionStorage.setItem(CT_CONNECT_ERROR_SESSION_KEY, message);
  } catch {
    /* ignore */
  }
}

export function consumeConnectTradeConnectError() {
  try {
    const message = sessionStorage.getItem(CT_CONNECT_ERROR_SESSION_KEY);
    if (message) sessionStorage.removeItem(CT_CONNECT_ERROR_SESSION_KEY);
    return message || null;
  } catch {
    return null;
  }
}

export function stripConnectTradeCallbackParams(search) {
  const params = new URLSearchParams(search);
  params.delete('ct');
  params.delete('ct_error');
  params.delete('ct_error_code');
  params.delete('ct_error_details');
  params.delete('ct_error_accounts');
  const next = params.toString();
  return next ? `?${next}` : '';
}
